// extracted by mini-css-extract-plugin
export default {"addToCartControl":"Q2-z","giftCard":"R2-z","btnContainer":"S2-z","cartButton":"T2-z","disabled":"U2-z"};